import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'vakorvakonbekend',
    standalone: false
})
export class VakOrVakOnbekend implements PipeTransform {
  transform(value: string): string {
    return value === undefined || value === null || value === '' ? 'Vak onbekend' : value;
  }
}
